<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Email Alerts',
          to: {
            name: 'EmailAlerts'
          }
        },
        { name: 'Create',
          to: {
            name: 'EmailAlertsInfoCreate',
          },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>Subscriber Create</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!--  -->
    <v-form ref="form" @submit.prevent="saveHandler">
      <EmailAlertsInfoCreateEdit></EmailAlertsInfoCreateEdit>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import EmailAlertsInfoCreateEdit from '@/views/I-5__IR-EmailAlerts/c/EmailAlertsInfoCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    EmailAlertsInfoCreateEdit,
  },
  created() {
    this.setShareholderEmail({
      type: 1,
      is_subscribe: false,
    });
  },
  computed: {
    ...mapState('shareholderEmail', ['shareholderEmail']),
  },
  methods: {
    ...mapActions('shareholderEmail', ['setShareholderEmail', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'EmailAlerts' });
    },
    saveHandler() {
      if (this.$refs.form.validate()) {
        this.save(this.shareholderEmail).then(() => {
          this.$router.push({ name: 'EmailAlerts' });
        });
      }
    },
  },
};
</script>

<style></style>
